import React from 'react'

import EditSettingsForm from '../../../../../EditSettingsForm/EditSettingsForm'
import {Size} from '../../../../../Input'
import Input from '../../../../../Input/Input'

import usePipelineParameterForm from './usePipelineParameterForm'

import styles from './PipelineParameterForm.css'

type PipelineParameterFormProps = {
  name?: string
  value?: string
  onConfirm: (name: string, value: string) => void
  onCancel: () => void
  onDelete?: () => void
}

function PipelineParameterForm({
  value = '',
  name = '',
  onCancel,
  onConfirm,
  onDelete,
}: PipelineParameterFormProps) {
  const {
    fieldName,
    fieldValue,
    isFormInvalid,
    parameterNameErrorMessage,
    parameterValueErrorMessage,
    parameterNameChangeInputHandler,
    parameterValueChangeInputHandler,
    confirmClickHandler,
  } = usePipelineParameterForm(name, value, onConfirm)

  return (
    <EditSettingsForm
      onConfirmClick={confirmClickHandler}
      onCancelClick={onCancel}
      onDeleteClick={onDelete}
      disabled={isFormInvalid}
    >
      <div className={styles.pipelineParameterWrapForm}>
        <div className={styles.pipelineParameterFormInput}>
          <Input
            placeholder={'Parameter Name'}
            onChange={parameterNameChangeInputHandler}
            value={fieldName}
            size={Size.FULL}
            aria-label="Parameter Name"
            type="text"
            error={parameterNameErrorMessage}
            autoComplete="off"
          />
        </div>
        <div>{'='}</div>
        <div className={styles.pipelineParameterFormInput}>
          <Input
            placeholder={'Value'}
            onChange={parameterValueChangeInputHandler}
            value={fieldValue}
            size={Size.FULL}
            aria-label="Value"
            error={parameterValueErrorMessage}
            autoComplete="off"
          />
        </div>
      </div>
    </EditSettingsForm>
  )
}

export default PipelineParameterForm
